import { Navigate, createBrowserRouter } from "react-router-dom";
import SignIn from "./pages/sign-in";
import SignUp from "./pages/sign-up";
import MainLayout from "./layout/main.layout";
import Home from "./pages/home";
import Api from "./pages/api";
import PaymentHistory from "./pages/payment-history";
import { isAuthenticated } from "./loaders/authentication";
import { PathnameUrl } from "./constants";
import GpuHub from "./pages/gpu-hub";
import IdentityVerification from "./pages/identity-verification";
import OrderManagement from "./pages/order-management";
import NotFound from "./pages/not-found";
import UserGuideManagement from "./pages/user-guide-management";
import VpsRental from "./pages/vps-rental";
import CloudGamingPage from "./pages/cloud-gaming";
import CloudImageHistory from "./pages/cloud-image-history";
import RefCodePage from "./pages/ref-user";
import ProfilePage from "./pages/profile";
import ChangePasswordPage from "./pages/change-password";
import ConfirmAccountPage from "./pages/confirm-account";
import EkycComponent from "./pages/identity-verification/ekyc.component";
import EKycConsent from "./pages/ekyc_consent-management";
import VerifyPhoneConsentPage from "./pages/verify-phone-consent";
import VerifyPhonePage from "./pages/verify-phone";
import PcComponentPage from "./pages/pc-component";
import IntroducePage from "./pages/info/introduce.page";
import ContactPage from "./pages/info/contact.page";
import TermsPage from "./pages/info/terms.page";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    loader: isAuthenticated,
    children: [
      {
        path: "",
        element: <GpuHub />,
      },
      {
        path: "api",
        element: <Api />,
      },
      {
        path: PathnameUrl.PC_COMPONENT,
        element: <PcComponentPage />,
      },
      {
        path: PathnameUrl.VPS_RENTAL,
        element: <VpsRental />,
      },
      {
        path: PathnameUrl.CLOUD_RENTAL,
        element: <CloudGamingPage />,
      },
      // Tạo Cloud giờ nằm ngay trên trang Cloud Gaming - Render
      {
        path: PathnameUrl.CREATE_CLOUD,
        element: <Navigate to={PathnameUrl.CLOUD_RENTAL} replace />,
      },
      {
        path: PathnameUrl.RECHARGE,
        element: <PaymentHistory />,
      },
      {
        path: PathnameUrl.EKYC,
        element: <EkycComponent />,
      },
      {
        path: PathnameUrl.EKYC_CONSENT,
        element: <EKycConsent />,
      },
      {
        path: PathnameUrl.VERIFY_PHONE_CONSENT,
        element: <VerifyPhoneConsentPage />,
      },
      {
        path: PathnameUrl.VERIFY_PHONE,
        element: <VerifyPhonePage />,
      },
      {
        path: PathnameUrl.IDENTITY_VERIFICATION,
        element: <IdentityVerification />,
      },
      {
        path: PathnameUrl.ORDER_MANAGEMENT,
        element: <OrderManagement />,
      },
      {
        path: PathnameUrl.ORDER_VPS_MANAGEMENT,
        element: <Navigate to={PathnameUrl.VPS_RENTAL} replace />,
      },
      {
        path: PathnameUrl.ORDER_CLOUD_MANAGEMENT,
        element: <Navigate to={PathnameUrl.ORDER_MANAGEMENT + "?type=cloud"} replace />,
      },
      {
        path: PathnameUrl.ORDER_CLOUD_HISTORY,
        element: <CloudImageHistory />,
      },
      {
        path: PathnameUrl.LOG_MANAGEMENT,
        // Quản lý Log đã bỏ khỏi client
        element: <Navigate to="/" replace />,
      },
      {
        path: PathnameUrl.USER_GUIDE_MANAGEMENT,
        element: <UserGuideManagement />,
      },
      {
        path: PathnameUrl.REF_CODE,
        element: <RefCodePage />,
      },
      {
        path: PathnameUrl.PROFILE,
        element: <ProfilePage />,
      },
    ],
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: PathnameUrl.INTRODUCE,
    element: <IntroducePage />,
  },
  {
    path: PathnameUrl.CONTACT,
    element: <ContactPage />,
  },
  {
    path: PathnameUrl.TERMS,
    element: <TermsPage />,
  },
  {
    path: PathnameUrl.CONFIRM_ACCOUNT,
    element: <ConfirmAccountPage />,
  },
  {
    path: PathnameUrl.CHANGE_PASSWORD,
    element: <ChangePasswordPage />,
  },
  {
    path: "/login",
    element: <SignIn />,
    loader: isAuthenticated,
  },
  {
    path: "/register",
    element: <SignUp />,
    loader: isAuthenticated,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
